import Constants from '../actions/types';
import { getRoundTitle } from '../utils';

const initialState = {
  blockingConfig: {
    maximumBlockSize: 40,
    blockingRounds: [],
    filteringEnabled: false,
    filteringThreshold: 0.0
  },
  loading: false,
  message: null,
  severity: null
};

const transformBlockingConfig = payload => {
  const blockingConfig = {
    ...payload,
    blockingRounds: payload.blockingRounds.map((round, index) => {
      return {
        id: index + 1,
        name: getRoundTitle(index + 1, round),
        fields: round.fields.map((field, idx) => {
          return {
            index: idx + 1,
            fieldName: field
          };
        })
      };
    })
  };
  return blockingConfig;
};

const blockingConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.BLOCKINGCONFIG_GET_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.BLOCKINGCONFIG_GET_SUCCESS: {
      const blockingConfig = transformBlockingConfig(action.payload);

      const newState = {
        ...state,
        blockingConfig: blockingConfig,
        loading: false
      };

      return newState;
    }

    case Constants.BLOCKINGCONFIG_GET_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.BLOCKINGCONFIG_SAVE_SUCCESS: {
      const newState = {
        ...state,
        message: 'Saved the blocking configuration successfully!',
        severity: 'info',
        loading: false
      };

      return newState;
    }

    case Constants.BLOCKINGCONFIG_SAVE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.BLOCKINGCONFIG_REPLACE_SUCCESS: {
      const blockingConfig = transformBlockingConfig(action.payload);
      const newState = {
        ...state,
        blockingConfig: blockingConfig,
        loading: false
      };

      return newState;
    }

    case Constants.BLOCKINGCONFIG_REPLACE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.BLOCKINGCONFIG_REINDEX_SUCCESS: {
      const newState = {
        ...state,
        message:
          'Initiated the job to regenerate blocking indexes successfully!',
        severity: 'info',
        loading: false
      };

      return newState;
    }

    case Constants.BLOCKINGCONFIG_REINDEX_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.BLOCKINGCONFIG_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default blockingConfigReducer;
